/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect } from "react";
import Form from "../../Helpers/Form/Form";
import { Offcanvas } from "react-bootstrap";
import FormHeader from "../../Helpers/Form/FormParts/FormHeader";
import { popupcontext } from "../../../context/Popupscontext";
import trans from "../../../utils";
import GroupsBody from "./GroupsBody";
import { useGetSpecificGroupQuery } from "../../../Redux/service/Groups/Groups";

export default function GroupsForm({ refetch }) {
	const { form, isEditing, currentGroupId } = useContext(popupcontext);
	const { refetch: groupRefetch, data: groupDetails } =
		useGetSpecificGroupQuery(currentGroupId, { skip: !currentGroupId });
	useEffect(() => {
		if (isEditing && currentGroupId) {
			groupRefetch();
		}
	}, [currentGroupId, isEditing, groupDetails, groupRefetch]);
	console.log("Group Details", groupDetails);
	return (
		<>
			<Form show={form}>
				<Offcanvas.Header>
					<FormHeader
						title={isEditing ? trans("Edit Group") : trans("Add new group")}
					/>
				</Offcanvas.Header>
				<div className="H-line"></div>
				<Offcanvas.Body>
					<GroupsBody refetch={refetch} Editvalues={groupDetails} />
				</Offcanvas.Body>
			</Form>
		</>
	);
}
